// extracted by mini-css-extract-plugin
module.exports = {"ResponsivePlaceholder":"_2u38Fa4mcRej4WQqKePxMk"};